// extracted by mini-css-extract-plugin
export default {"container":"Promotion_container__U+Xaz","close":"Promotion_close__5Dsgd"};